import React from "react";

const Button = ({
  label,
  disable,
  onClick,
  className,
}) => {
  return (
    <div className={`${className ? className + ' needHelp__btnWrapper' : 'needHelp__btnWrapper'}`}>
      <button
        disabled={!!disable}
        className={`bluePrimarybtn${!!disable ? ' noSelection' : ''}`}
        onClick={onClick}
      >{label}</button>
    </div>
  )
}

export default Button;
